import { createRouter, createWebHistory } from 'vue-router';
import { sessionStarted, useSessionStore } from '@/stores/session';

// Trips are addressed by the booking UUID (box API); the EM… code is only shown to people.
// Deep links: /trips/<booking id>, /trips/<booking id>/review, /listings/<id>, /profile.
const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    { path: '/', name: 'explore', component: () => import('@/views/ExploreView.vue'), meta: { tab: true } },
    { path: '/listings/:id', name: 'listing', component: () => import('@/views/ListingView.vue'), props: true },
    { path: '/listings/:id/book', name: 'checkout', component: () => import('@/views/CheckoutView.vue'), props: true, meta: { auth: true } },
    { path: '/favorites', name: 'favorites', component: () => import('@/views/FavoritesView.vue'), meta: { tab: true } },
    { path: '/trips', name: 'trips', component: () => import('@/views/TripsView.vue'), meta: { tab: true } },
    { path: '/trips/:id', name: 'trip', component: () => import('@/views/TripView.vue'), props: true, meta: { auth: true } },
    { path: '/trips/:id/pay', redirect: (to) => ({ name: 'trip', params: { id: to.params.id } }) },
    { path: '/trips/:id/success', name: 'trip-success', component: () => import('@/views/TripSuccessView.vue'), props: true, meta: { auth: true } },
    { path: '/trips/:id/review', name: 'review', component: () => import('@/views/ReviewView.vue'), props: true, meta: { auth: true } },
    { path: '/profile', name: 'profile', component: () => import('@/views/ProfileView.vue'), meta: { tab: true } },
    { path: '/support', name: 'support', component: () => import('@/views/SupportView.vue'), meta: { auth: true } },
    { path: '/login', name: 'login', component: () => import('@/views/LoginView.vue') },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

router.beforeEach(async (to) => {
  const session = useSessionStore();
  if (to.meta.auth && session.token && !session.me) await sessionStarted();
  if (to.meta.auth && !session.isLoggedIn) return { name: 'login', query: { next: to.fullPath } };
  return true;
});

export default router;
